import useRoutes from "@/react/Webshop/hooks/useRoutes";
import Popup, { PopupActions, PopupButton, PopupHeading, } from "@/react/components/Common/Popup";
import Box from "@mui/material/Box";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Trans } from "react-i18next";
import { generatePath } from "react-router";
import EpmsImage from "@/react/components/Common/EpmsImage";
import makeStyles from "@mui/styles/makeStyles";
import { useAPI } from "@/react/lib/common";
import useCopyrightDialog from "@/react/Webshop/hooks/useCopyrightDialog";
const useStyles = makeStyles((theme) => ({
    downloadImage: {
        height: "100%",
        maxHeight: "40vh",
        minHeight: 0,
        backgroundPosition: "center center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
    },
    watermarkText: {
        fontSize: "12px",
        textAlign: "center",
        color: "#aaa",
    },
    backgroundList: {
        listStyle: "none",
        //backgroundColor: 'red',
        margin: 0,
        padding: 0,
        maxWidth: "100%",
        overflowX: "auto",
        display: "inline-flex",
        boxSizing: "border-box",
        "& > li:first-child": {
            marginLeft: theme.spacing(2),
        },
        "& > li": {
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            maxHeight: "100%",
            //backgroundColor: 'blue',
            "& > div": {
                textAlign: "center",
                fontSize: "14px",
                flexBasis: "40px",
            },
            "& img": {
                minHeight: 0,
                height: "130px",
                outline: "1px solid #B5B5B580",
                margin: "4px",
                boxSizing: "border-box",
            },
            "&$selectedBackground": {
                "& img": {
                    outline: `4px solid ${theme.palette.secondary.main}`,
                },
            },
            "&$selectedBackground $transparentBackground": {
                outline: `4px solid ${theme.palette.secondary.main}`,
            },
            "& $transparentBackground": {
                width: "100px",
                height: "130px",
                margin: "4px",
                flexGrow: 1,
            },
        },
    },
    description: {},
    selectedBackground: {},
    transparentBackground: {
        backgroundColor: "white",
        backgroundImage: "linear-gradient(45deg, #eee 25%, transparent 25%), linear-gradient(-45deg, #eee 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #eee 75%), linear-gradient(-45deg, transparent 75%, #eee 75%)",
        backgroundSize: "20px 20px",
        backgroundPosition: "0 0, 0 10px, 10px -10px, -10px 0px",
        backgroundRepeat: "repeat",
    },
}));
const ChoosePictureBackgroundDialog = ({ picture, onClose, }) => {
    const [backgrounds] = useAPI("/ajax/template/get_image_backgrounds.php?uuid=" + picture.uuid);
    const classes = useStyles();
    const [currentBackground, setCurrentBackground] = useState(null);
    const routes = useRoutes();
    const { getCopyrightTriggerProps, copyrightDialog } = useCopyrightDialog();
    const consumeCloseRef = useRef(null);
    const downloadFile = () => {
        var _a;
        if (!currentBackground) {
            return;
        }
        let background = "transparent";
        if (currentBackground != "transparent") {
            background = currentBackground.uuid;
        }
        const link = generatePath(routes["pictureset.download.file.background"].path, { uuid: picture.uuid, background: background });
        (_a = consumeCloseRef.current) === null || _a === void 0 ? void 0 : _a.call(consumeCloseRef);
        document.location.href = link;
    };
    const [defaultBackground, bgs] = useMemo(() => {
        if (!backgrounds) {
            return [null, []];
        }
        let bg = backgrounds.find((bg) => bg.default);
        if (!bg && backgrounds.length > 0) {
            bg = backgrounds[0];
        }
        const rest = backgrounds.filter((b) => !bg || b.uuid != bg.uuid);
        return [bg, rest];
    }, [backgrounds]);
    useEffect(() => {
        if (!backgrounds) {
            return;
        }
        if (defaultBackground) {
            setCurrentBackground(defaultBackground);
        }
    }, [backgrounds, defaultBackground]);
    let styles = {};
    if (currentBackground && currentBackground != "transparent") {
        styles = {
            backgroundImage: `url(${currentBackground.src}`,
        };
    }
    return (React.createElement(Popup, { fullScreen: true, onClose: onClose, consumeCloseRef: consumeCloseRef },
        React.createElement(PopupHeading, null,
            React.createElement(Trans, null, "Select picture background")),
        React.createElement(Box, { display: "flex", flexDirection: "column", flexGrow: 1, sx: { minHeight: 0, maxWidth: "100vw" } },
            React.createElement(Box, { flex: 1, sx: { maxWidth: "100%", maxHeight: "60%" }, mb: 2, display: "flex", justifyContent: "center" },
                React.createElement(EpmsImage, Object.assign({ className: `${classes.downloadImage} ${currentBackground == "transparent"
                        ? classes.transparentBackground
                        : ""}`, style: styles }, getCopyrightTriggerProps(), { uuid: picture.uuid }))),
            React.createElement("p", { className: classes.watermarkText },
                React.createElement(Trans, null, "All watermarks will be removed when downloading")),
            React.createElement("ul", { className: classes.backgroundList },
                defaultBackground && (React.createElement("li", { onClick: () => setCurrentBackground(defaultBackground), className: defaultBackground == currentBackground
                        ? classes.selectedBackground
                        : "" },
                    React.createElement(BackgroundPreview, { background: defaultBackground }),
                    React.createElement("div", { className: classes.description },
                        React.createElement(Trans, null, "Default background")))),
                React.createElement("li", { onClick: () => setCurrentBackground("transparent"), className: "transparent" == currentBackground
                        ? classes.selectedBackground
                        : "" },
                    React.createElement(BackgroundTransparentPreview, null),
                    React.createElement("div", { className: classes.description },
                        React.createElement(Trans, null, "Transparent"))),
                bgs.map((bg) => {
                    return (React.createElement("li", { key: bg.uuid, onClick: () => setCurrentBackground(bg), className: bg == currentBackground ? classes.selectedBackground : "" },
                        React.createElement(BackgroundPreview, { background: bg }),
                        React.createElement("div", null, "\u00A0")));
                }))),
        React.createElement(PopupActions, null,
            React.createElement(PopupButton, { secondary: true, onClick: onClose },
                React.createElement(Trans, null, "Cancel")),
            React.createElement(PopupButton, { onClick: downloadFile },
                React.createElement(Trans, null, "Download"))),
        copyrightDialog));
};
const BackgroundPreview = ({ background, }) => {
    return React.createElement("img", { src: background.src });
};
const BackgroundTransparentPreview = () => {
    const classes = useStyles();
    return React.createElement("div", { className: classes.transparentBackground });
};
export default ChoosePictureBackgroundDialog;
